export const appTitle: string = "Proh";
export const metaDescription: string = "Collab manager, advisor & marketer.";
export const metaKeywords: string = "gatsby, mui";

export const siteAuthor = `Gerardo I. Ornelas <gerardo@ornelas.tech>`;
export const siteUrl = `https://www.ornelas.tech`;
